import lazyframe from "lazyframe";

export default () => {
  if (document.querySelector(".video-player__lazyframe")) {
    let elements = document.querySelector(".video-player__lazyframe");
    let sliderViewport = document.querySelector(".js-efficiency-slider-viewport");
  
    lazyframe(elements, {
      onAppend: iframe => {
        iframe.setAttribute("allow", "autoplay");
        if (sliderViewport) {
          sliderViewport.slick("slickPause");
          sliderViewport.addClass("js-player-is-on")
        }
      }
    });
  };


  // $(elements).on("keydown", function(event) {
  //   const keycode = (event.keyCode ? event.keyCode : event.which);
  //   if(keycode === 13) {
  //     $(this).trigger("click");
  //   }
  // });
};